import type { EntryTag } from '@/lib/timesheet-api';

/**
 * The tags on an entry.
 *
 * A tag may carry its own colour, chosen by whoever made it, so the chip is tinted
 * from that value rather than from the theme palette - it is the tag's identity and
 * the reason somebody set it. Where there is no colour, it falls back to a neutral
 * chip rather than picking one, because an invented colour reads as meaningful.
 */
export function TagChips({ tags }: { tags: EntryTag[] }) {
  if (tags.length === 0) return null;
  return (
    <span className="inline-flex flex-wrap gap-1">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className="inline-flex items-center rounded-full border px-1.5 py-px text-[10px] font-medium leading-4"
          style={
            tag.color
              ? {
                  // The author's colour at low opacity for the fill, full strength
                  // for the border and text, so a bright green stays readable.
                  borderColor: `${tag.color}66`,
                  backgroundColor: `${tag.color}1a`,
                }
              : undefined
          }
        >
          {tag.name}
        </span>
      ))}
    </span>
  );
}
